import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { AuditoriaAccion } from '@enum/auditoria/auditoria-keys.enum';
import { InscripcionTraceService } from './inscripcion-trace.service';

// Presupuestos deliberadamente holgados: el backend se satura con el trafico de la
// manana y una respuesta lenta es preferible a un error para el usuario. El corte
// sigue existiendo solo para no dejar spinners infinitos.
const TIMEOUT_JSON_MS = 90000;
const TIMEOUT_UPLOAD_MS = 300000;
// Las consultas paginadas de solicitudes enriquecen todo el universo del rango antes
// de filtrar por texto: son las mas caras del sistema.
const TIMEOUT_SOLICITUDES_MS = 300000;

/**
 * Corta las peticiones que quedan colgadas (la causa raíz de los "spinners
 * infinitos") y deja el timeout registrado en la traza de inscripción.
 *
 * Se salta el endpoint de auditoría para no crear recursión al loguear el
 * propio timeout.
 */
@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {

    constructor(private inscripcionTrace: InscripcionTraceService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const esAuditoria = req.url.includes('/signo-auditoria');
        const esUpload = req.url.includes('/media/');
        const esSolicitudesPaginadas =
            req.url.includes('/solicitudes/') && req.url.toLowerCase().includes('paged');
        const limiteMs = esUpload
            ? TIMEOUT_UPLOAD_MS
            : esSolicitudesPaginadas
            ? TIMEOUT_SOLICITUDES_MS
            : TIMEOUT_JSON_MS;
        const iniciado = Date.now();

        return next.handle(req).pipe(
            timeout(limiteMs),
            catchError((error) => {
                const esTimeout = error && error.name === 'TimeoutError';

                if (esTimeout && !esAuditoria) {
                    this.inscripcionTrace.logError(
                        AuditoriaAccion.TIMEOUT,
                        new Error(`Tiempo de espera agotado (${limiteMs} ms)`),
                        {
                            paso: `${req.method} ${req.url}`,
                            duracionMs: Date.now() - iniciado,
                            payload: { url: req.url, method: req.method, limiteMs },
                        },
                    );
                    return throwError(new Error(
                        `El servidor tardó demasiado en responder (${Math.round(limiteMs / 1000)}s). Verifique su conexión e intente nuevamente.`,
                    ));
                }

                return throwError(error);
            }),
        );
    }
}
